import { classNames } from "../../../utils/classNames"
import React, { useRef } from "react"
import { getRandRange } from "../../../utils/general"

type Props = {
    className?: string
}

/** Renders one line of Skeleton loading */
export const Skeleton = (props: Props) => {
    const rand = useRef(getRandRange(0, 4))
    return <div className={classNames(classes.base, classes.widths[rand.current], props.className)} />
}

const classes = {
    base: "h-2.5 animate-pulse rounded-full bg-gray-200",
    widths: ["w-[50%]", "w-[60%]", "w-[70%]", "w-[80%]", "w-[90%]"],
}
